// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/common.css'
import Vuex from 'vuex'
// import store from './store'

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(ElementUI)
Vue.use(Vuex)
// 全局变量
const store = new Vuex.Store({
  state: {
    isCollapse: false,
    headTitle: '概览',
    schoolID: '',
    host: 'https://test1.smartclass.cn:8085',
    deviceCategory: 0
  }
})
Vue.http.headers.common['AccessToken'] = 'ceshi1'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js